import { useEffect, useRef } from 'react';

import useIntersection from '../../hooks/useIntersection';

const AutoplayVideo = ({
  className,
  poster,
  src,
  videoClassName,
}: {
  className?: string;
  videoClassName?: string;
  src: string;
  poster: string;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [inViewRef, inView] = useIntersection({ rootMargin: '100% 0px' });

  useEffect(() => {
    if (videoRef.current) {
      if (inView) {
        // The play method returns a promise, and if it throws an error because of a browser policy
        // we must catch it to avoid a crash for an unhandled promise rejection.
        videoRef.current.play().catch((error) => {
          console.warn(`Failed to autoplay video`, error);
        });
      } else {
        videoRef.current.pause();
      }
    }
  }, [inView]);

  // Once loaded, AspectRatioStyles can be removed and will make images that are smaller than their predefined size not take up as much space.
  return (
    <div className={className} ref={inViewRef}>
      <video
        autoPlay
        className={videoClassName}
        crossOrigin="anonymous"
        disableRemotePlayback={true}
        loop
        muted
        playsInline
        poster={poster}
        // eslint-disable-next-line react/no-unknown-property
        preload="none"
        ref={videoRef}
        src={src}
        x-webkit-airplay="deny"
      />
    </div>
  );
};

export default AutoplayVideo;
